import apiCart from '@/model/login'

const state = {
  cartList: [],
  totalQuantity: 0, // 总商品件数
  totalGoods: 0, // 总商品种类数
  checked_ids: [] // 购物车种选中的商品
}

const getters = {
  totalQuantity: state => state.cartList.reduce((prev, cur) => {
    return prev.concat(cur.goodsList)
  }, []).length,
  totalGoods: (state) => state.totalGoods,
  top_cart: (state) =>
    state.cartList &&
    state.cartList.reduce((a, b) => {
      b.goodsList.forEach((item) => {
        item.shopId = b.shop.shopId
      })
      return a.concat(b.goodsList)
    }, []),
  cartList: (state) => state.cartList,
  checked_ids: (state) => state.checked_ids
}

const mutations = {
  setCartList: (state, { cartList }) => {
    state.cartList = cartList || []
  },
  setTotalQuantity: (state, { cartList }) => {
    const list = (cartList || []).reduce((prev, cur) => {
      return prev.concat(cur.goodsList)
    }, [])
    state.totalQuantity = list.length
    // state.total_quantity = totalQuantity 这里不是注释未删除而是这里本应该后台改为正确数量，但是没有改只能前端来兼容处理一下
  },
  setTotalProduct: (state, { totalGoods }) => {
    state.totalGoods = totalGoods || 0
  },
  setCheckedIds: (state, { ids }) => {
    state.checked_ids = ids || []
  }
}

const actions = {
  async getCarts({ commit }) {
    try {
      const result = await apiCart.getCartDetail()
      commit('setCartList', result)
      commit('setTotalQuantity', result)
      commit('setTotalProduct', result)
    } catch (error) {
      console.log(error)
    }
  },
  // eslint-disable-next-line
  async addToCart({ commit }, data) {
    try {
      await apiCart.addToCart(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // eslint-disable-next-line
  async deleteProduct({ commit }, data) {
    try {
      await apiCart.deleteFromCart(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // eslint-disable-next-line
  updateCart({ commit }, data) {
    try {
      return new Promise((resolve) => {
        const list = apiCart.updateCart(data)
        if (list) resolve(list)
      })
    } catch (error) {
      return Promise.reject(error)
    }
  },
  // eslint-disable-next-line
  async clearCart({ commit }, data) {
    try {
      await apiCart.clearCart(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async calculateCart({ commit }, data) {
    try {
      const result = await apiCart.countSelected(data)
      commit('setCheckedIds', { ids: data.data.map((item) => item.product_id) })
      return result
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
